import { render, staticRenderFns } from "./PostOP.vue?vue&type=template&id=2a488702"
import script from "./PostOP.vue?vue&type=script&lang=js"
export * from "./PostOP.vue?vue&type=script&lang=js"
import style0 from "./PostOP.vue?vue&type=style&index=0&id=2a488702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports